import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import useModal from '@hooks/ui/useModal';

function DeleteAllMyMenuModal() {
    const { closeModal } = useModal();
    const handleDeleteAllMyMenu = () => {
        closeModal();
    };
    return (
        <Column spacing={16} fullWidth
            align='center' >
            <Text align='center' size='3xl' fontWeight='bold'>
                저장하신 MY메뉴를 모두<br/>
                삭제할까요?
            </Text>
            <Column fullWidth spacing={10}>
                <Button variant='secondary'
                    fullWidth
                    onClick={closeModal} >
                    취소
                </Button>
                <Button fullWidth
                    onClick={handleDeleteAllMyMenu}>
                    삭제
                </Button>
            </Column>
        </Column>
    );
}

export default DeleteAllMyMenuModal;
